// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"4ec17a3c","274":"2fe35e37","508":"43c45154"}[chunkId] + ".chunk.css";
};